import { Button } from 'design-system/base';
import { router } from 'expo-router';
import type { ReactElement } from 'react';

interface LinkButtonProps {
  href: string;
  text: string;
}

export const LinkButton = ({ text, href }: LinkButtonProps): ReactElement => {
  return <Button onPress={() => router.push({ pathname: href })} text={text} />;
};
